import { Component, Input } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import { GameService, MissionService, LanguageService, PoiService, GeocodingService, VoiceService } from '../../_services/index';

import { Mission, Voice } from '../../classes/index';
import { MapResources } from '../../_resources/map.resources';

import { NbDialogService } from '@nebular/theme';

import { MultilangEditModalComponent } from '../editor/multilang-edit-modal.component';
import { ConfirmModalComponent } from '../modals/confirm-modal.component';
import { TemplateUpdateModalComponent } from '../template-update/template-update-modal.component';

import { Storage, ref, uploadBytes, percentage } from '@angular/fire/storage';
import { deleteField } from '@angular/fire/firestore';

import { environment } from '../../../environments/environment';

import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil, finalize } from 'rxjs/operators';
import { EditMissionReferencesComponent } from '../edit-mission-references/edit-mission-references.component';

import md5Hex from 'md5-hex';

import { IdTools } from '../../utils/id-tools';

@Component({
    selector: 'app-mission-preview',
    templateUrl: './mission-preview.component.html',
    styleUrls: ['./mission-preview.component.scss'],
    standalone: false
})

export class MissionPreviewComponent {

  private destroy$: Subject<void> = new Subject<void>();

  @Input() gameId;
  @Input() templateId;
  @Input() openMission;

  _mission;
  @Input() 
  set mission(mission){
    if(mission && (!this._mission || mission.id != this._mission.id)){
      if(this.poiSubscriber){
        this.poiSubscriber.unsubscribe();
      }
      delete this.poi;
      if(mission.poiId){
        this.poiSubscriber = this.poiService.getPoi(mission.poiId)
        .subscribe(async poi => {
          let isnew = (!this.poi || this.poi.id !== poi.id);
          this.poi = poi;
          if(isnew && !poi.sitelinks){
            await this.poiService.getSiteLinks(this.poi).toPromise();
          }
          if(poi.name && JSON.stringify(mission.poiName) !== JSON.stringify(poi.name)){
            this.missionService.updateMission(this._mission, {poiName: poi.name});
          }
        });
      }
      
      if(this.pictureSubscriber){
        this.pictureSubscriber.unsubscribe();
      }
      this.pictureSubscriber = this.missionService.listMissionPictures(mission.collectionPath, mission.id)
      .subscribe(pictures => {
        //console.log('got pictures:'+pictures);
        this.pictures = pictures;
      });
      if(this.wrongAnswerSubscriber){
        this.wrongAnswerSubscriber.unsubscribe();
      }
      if(mission.type == 'REWARD' && mission.rewardMode == 'RIDDLE')
      this.wrongAnswerSubscriber = this.missionService.listMissionWrongAnswers(mission.collectionPath, mission.id)
      .subscribe(wrongAnswers => {
        //console.log('got pictures:'+pictures);
        this.wrongAnswers = wrongAnswers;
        //this.setWrongAnswers()
      });

      if(mission.hasExternalLink && mission.externalUrl){
        console.log('external url:'+mission.externalUrl);
        let url = mission.externalUrl;
        if(url.indexOf('?')>=0){
          url += '&timestamp='+new Date().getTime()+'&lang='+this.languageService.currentLang;
        }
        else{
          url += '?timestamp='+new Date().getTime()+'&lang='+this.languageService.currentLang;
        }
        this.externalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
      else{
        delete this.externalUrl;
      }
      
    }
    this._mission = mission;
    if(this.game?.ttsVoiceId || this.template?.ttsVoiceId){
      console.log('getBaseCollectionRef:'+this.getBaseCollectionRef());
      if(this.voicesSubscriber){
        this.voicesSubscriber.unsubscribe();
      }
      this.voicesSubscriber = this.voiceService.listVoices(this.getBaseCollectionRef()+'/voices', mission.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(voices => {
        console.log('Found voices:'+voices.length);
        this.voices = voices;
      });
      if(this.template){
        console.log('getTemplateCollectionRef:'+'game_templates'+'/'+this.template.id);
        if(this.templateVoicesSubscriber){
          this.templateVoicesSubscriber.unsubscribe();
        }
        this.templateVoicesSubscriber = this.voiceService.listVoices('game_templates'+'/'+this.template.id+'/voices', mission.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe(voices => {
          console.log('Found voices:'+voices.length);
          this.templateVoices = voices;
        });
      }
    }
    
  }

  @Input() templateMission;
  
  @Input() workingLanguages;
  @Input() languages;
  @Input() templateWorkingLanguages;

  
  @Input() game;
  @Input() template;
  @Input() missions;
  @Input() objects;
  @Input() roles;
  @Input() characters;

  @Input() missionStats: BehaviorSubject<any>;

  externalUrl;

  wrongAnswerSubscriber;
  wrongAnswers = [];

  pictureSubscriber;
  pictures = [];

  poiSubscriber;
  poi;

  voicesSubscriber;
  voices;
  
  templateVoicesSubscriber;
  templateVoices;

  sectionEdit = {};

  //map;
  mapStyles;

  //language localStorage
  //storedLanguages

  constructor(
    public gameService: GameService,
    public missionService: MissionService,
    public poiService: PoiService,
    public geocodingService: GeocodingService,
    private voiceService: VoiceService,
    public languageService: LanguageService,
    private storage: Storage,
    private dialogService: NbDialogService,
    protected sanitizer: DomSanitizer
  ) {  
    this.mapStyles = MapResources.mapStyles;
  }
  
  
  ngOnInit() {
    console.log('MissionPreviewComponent init');
    if(this.languages) this.languages = this.languageService.sortLanguages(this.languages); 
    else this.languages = this.languageService.sortLanguages(this.workingLanguages);
  }

  changePosition(old_index, new_index){
    //this._mission.riddleClues
    if (new_index >= this._mission.riddleClues.length) {
      var k = new_index - this._mission.riddleClues.length + 1;
      while (k--) {
        this._mission.riddleClues.push(undefined);
      }
    }
    this._mission.riddleClues.splice(new_index, 0, this._mission.riddleClues.splice(old_index, 1)[0]);
    //save position
    this.savePositionRiddleClues()
  }

  savePositionRiddleClues(){
    this.missionService.updateMission(this._mission, {riddleClues: this._mission.riddleClues})
    .then(res => {
      console.log('Riddle clues position updated');
    });
  }

  enableGameLanguage(){

    this.languageService.sortLanguages(this.languages)
  }

  getMission(missionId){
    if(this.missions){
      return this.missions.filter(function( mis ) {return mis.id == missionId})[0];
    }
    return null;
  }

  getObject(objectId){
    if(this.objects){
      return this.objects.filter(function( obj ) {return obj.id == objectId})[0];
    }
    return null;
  }

  getRole(roleId){
    if(this.roles){
      return this.roles.filter(function( role ) {return role.id == roleId})[0];
    }
    return null;
  }

  getObjects(list){
    if(!this.objects){
      return [];
    }
    let objectList = [];
    for(let objectId of list){
      let foundObjs = this.objects.filter(function( obj ) {return obj.id == objectId});
      if(foundObjs && foundObjs[0]){
        objectList.push(foundObjs[0]);
      }
    }
    return objectList;
  }

  checkMoods(){
    let fields = ['description','unlockedDescription','forkText','riddleText','successMessage','failMessage'];
    for(let field of fields){
      let update = false;
      if(this._mission && this._mission[field] && this._mission[field].blocks){
        for(let block of this._mission[field].blocks){
          if(this.checkBlock(block)){
            update = true;
          }
        }
      }
      if(update){
        let data:any = {};
        data[field] = this._mission[field];
        console.log('Update '+field+': '+JSON.stringify(data));
        this.missionService.updateMission(this._mission, data)
      }
    }
    if(this._mission.failMessages){
      let update = false;
      for(let message of this._mission.failMessages){
        if(this.checkBlock(message)){
          update = true;
        }
      }
      if(update){
        console.log('Update fail messages: '+JSON.stringify(this._mission.failMessages));
        this.missionService.updateMission(this._mission, {failMessages:this._mission.failMessages})
      }
    }
    if(this._mission.riddleClues){
      let update = false;
      for(let clue of this._mission.riddleClues){
        if(this.checkBlock(clue.labels)){
          update = true;
        }
      }
      if(update){
        console.log('Update clues: '+JSON.stringify(this._mission.riddleClues));
        this.missionService.updateMission(this._mission, {riddleClues:this._mission.riddleClues})
      }
    }
  }

  checkBlock(block){
    let update = false;
    if(block.type == 'dialog'){
      console.log('Found dialog:'+block.data.characterId+'/'+block.data.moodId);
      console.log('charIconURL:'+block.data.charIconURL);
      for(let character of this.characters){
        if(character.id == block.data.characterId){
          console.log('Found character, identify mood:'+block.data.moodId);
          for(let mood of character.moods){
            if(mood.id == block.data.moodId){
              console.log('mood found:'+mood.id);
              console.log('icon:'+mood.fileURL);
              if(mood.fileURL !== block.data.charIconURL){
                console.log('update moodId based on url');
                for(let mood of character.moods){
                  if(mood.fileURL == block.data.charIconURL){
                    console.log('update moodId:'+mood.id+' for char url:'+block.data.charIconURL);
                    block.data.moodId = mood.id;
                    update = true;
                  }
                }
                break;
              }
            }
          }
        }
      }
    }
    return update;
  }

  hasPictures(unlocked){
    for(let pic of this.pictures){
      if((pic.isUnlocked && unlocked) || (!pic.isUnlocked && !unlocked)){
        return true;
      }
    }
    return false;
  }

  isTxtMapEmpty(obj) {
    if(obj.blocks){
      return obj.blocks.length==0;
    }
    for(var key in obj) {
        if(obj.hasOwnProperty(key) && obj[key] && obj[key].trim() !== '')
            return false;
    }
    return true;
  }

  editText(editModel, saveKey, saveModel, htmlMode = true){
    event.stopPropagation();
    this.dialogService.open(MultilangEditModalComponent, { 
      context: {
        model: editModel,
        editMode: true,
        defaultLang: this.game ? this.game.defaultLang : this.template ? this.template.defaultLang : null,
        htmlMode: htmlMode,
        languages: this.languages
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Save new txt with key:'+saveKey);
        console.log('Save new txt values-saveModel:'+JSON.stringify(saveModel));
        console.log('Save new txt values-res[saveKey]:'+JSON.stringify(res[saveKey]));
        let data:any = {};
        data[saveKey] = saveModel;
        this.missionService.updateMission(this._mission, data)
        .then(res => {
          console.log('Mission data updated');
        });
      }
      else{
        console.log('Rejected');
      }
    });
  }

  deleteListEl(array, objectId, saveKey, saveModel){
    var index = array.indexOf(objectId);
    if (index !== -1){
      array.splice(index, 1);
      let data:any = {};
      data[saveKey] = saveModel;
      this.missionService.updateMission(this._mission, data)
      .then(res => {
        console.log('Mission data updated');
      });
    }
  }

  deleteMapEl(map, objectId, saveKey, saveModel){
    delete map[objectId];
    let data:any = {};
    data[saveKey] = saveModel;
    this.missionService.updateMission(this._mission, data)
    .then(res => {
      console.log('Mission data updated');
    });
  }

  deletePoiLink(){
    this.missionService.updateMission(this._mission, {
      poiId: deleteField(),
      poiName: deleteField()
    })
    .then(res => {
      console.log('Mission data updated');
      delete this.poi;
    });
  }

  toggleHidePoi(){
    this._mission.hidePoiIfNotComplete = !this._mission.hidePoiIfNotComplete;
    this.missionService.updateMission(this._mission, {hidePoiIfNotComplete: this._mission.hidePoiIfNotComplete});
  }

  toggleNoPoiPopup(){
    this._mission.noPoiPopupWhenCompleted = !this._mission.noPoiPopupWhenCompleted;
    this.missionService.updateMission(this._mission, {noPoiPopupWhenCompleted: this._mission.noPoiPopupWhenCompleted});
  }

  async setGameStartLocation(){
    console.log('lat:'+ this._mission.latitude);
    console.log('lng:'+ this._mission.longitude);
    this.geocodingService.geocode(null, this._mission.latitude, this._mission.longitude)
    .subscribe(
      location => {
        //location.address
        if(location.address){
          this.missionService.updateMission(this._mission, {location: location.address});
          this.gameService.updateGame(this.gameId, {location: location.address, latitude:this._mission.latitude, longitude:this._mission.longitude});
          this.gameService.listGames()
        }
      },
      err => {
        console.error(err);
      }
    );
    
  }

  resetWrongAnswers(){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete wrong answers?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        for(let answer of this.wrongAnswers){
          console.log('delete answer:'+answer.id);
          await this.missionService.deleteWrongAnswer(this._mission.collectionPath, this._mission.id, answer.id);
        }
        await this.missionService.updateMission(this._mission, {wrongAnswersAlertTriggered: deleteField(), wrongAnswerCount: deleteField()})
      }
    });
  }

  toggleRiddleVerified(){
    let data:any = {customRiddleVerified: !this._mission.customRiddleVerified};
    if(data.customRiddleVerified){
      //data.customRiddle = false;
      data.customRiddleProposed = false;
    }
    this.missionService.updateMission(this._mission, data);
  }

  save(data){
    this.missionService.updateMission(this._mission, data)
  }

  getBaseCollectionRef(){
    return (this.gameId ? 'games' : 'game_templates')+'/'+(this.gameId ? this.gameId : this.templateId);
  }

  getEditPath(){
    return '/pages/'+(this.gameId ? 'game' : 'template')+'/'+(this.gameId ? this.gameId : this.templateId)+'/edit-missions/'+this._mission?.id;
  }

  getChoiceStats(choiceProp, choiceUid) {
    
    if(!this.missionStats) return null
    
    return this.missionStats.pipe(
      // take(1), 
      map(stats => {
        return stats?.[choiceProp]?.[choiceUid]
      })
    )
  }

  async applyChanges(attribute, type){
    console.log('applyChanges for '+attribute+' / '+type);
    if(type == 'all'){
      console.log('languages:'+this.workingLanguages);
      await this.updateGamesFromMissionTemplate(attribute, this.workingLanguages);
    }
    else{
      console.log('languages:'+this.languages);
      await this.updateGamesFromMissionTemplate(attribute, this.languages);
    }
  }

  applyStructChanges(attribute){
    console.log('update struct in games:'+this.templateId);
    let attrs = [attribute];
    if(!attribute){
      attrs = [];
      Array.prototype.push.apply(attrs, Mission.structFields);
    }
    this.openTemplateUpdatePopup(attrs, null);
    /*this.gameService.listTemplateGames(this.templateId)
    .pipe(take(1))
    .subscribe(async games => {
      //console.log('Found games inheriting from this template:'+games.length);
      let missions = await this.missionService.listMissionsById(this.missions[0].id).pipe(take(1)).toPromise();
      for(let game of games){
        game.missions = missions.filter(mission => mission.gameId == game.id);
      }
      
      await this.missionService.listGameModifsFromTemplate([this.missions[0]], games, Mission.structFields, []);
      
    });*/
  }

  /*updateWalter(){
    this.gameService.listTemplateGames(this.templateId)
    .pipe(take(1))
    .subscribe(async games => {
      //console.log('Found games inheriting from this template:'+games.length);
      let missions = await this.missionService.listMissionsById('6v614ulNmrUbMVF4hqwt').pipe(take(1)).toPromise();
      for(let mission of missions){
        if(mission.type == 'REWARD' && (!mission.reward || mission.reward != 20)){
          console.log('Mission reward should be updated:'+mission.reward);
          await this.missionService.updateMission(mission, {reward:20});
        }
      }
    });
  }*/

  /*Push update to games that are linked to this template
    Parameters:
    mission (null => update all game)
    attribute (null => update all attributes)
  */
  updateGamesFromMissionTemplate(attribute, languages){
    console.log('update lang in games:'+this.templateId);
    let attrs = [attribute];
    if(!attribute){
      attrs = [];
      Array.prototype.push.apply(attrs, Mission.translatedFields);
      Array.prototype.push.apply(attrs, Mission.translatedLists);
    }
    this.openTemplateUpdatePopup(attrs, languages);
  }

  checkSelection(index){
    this._mission.forkSelections[index].correct = !this._mission.forkSelections[index].correct;
    console.log('forkSelections',this._mission.forkSelections)
    this.saveCheckedSelection()
  }
  
  saveCheckedSelection(){
    this.missionService.updateMission(this._mission, {forkSelections: this._mission.forkSelections})
    .then(res => {
      console.log('forkSelections updated');
    });
  }

  openTemplateUpdatePopup(attrs, languages){
    console.log('openTemplateUpdatePopup:'+attrs);
    this.dialogService.open(TemplateUpdateModalComponent, { 
      context: {
        templateId: this.templateId,
        missions: [this._mission],
        attributes: attrs,
        languages: languages,
        characters: this.characters
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        
      }
    });
  }

  editeRef(){
    this.dialogService.open(EditMissionReferencesComponent, { 
      context: {
        templateId: this.templateId,
      }, closeOnBackdropClick: false
    }).onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
    });
  }

  updateFieldFromTemplate(field){
    if(this._mission.customRiddle){
      this.dialogService.open(ConfirmModalComponent, { 
        context: {
          title: 'Confirmation',
          message: `Are you sure you want to reset field ${field} for this mission?`
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(async res => {
        if(res){
          this.updateField(field);
        }
      });
    }
    else{
      this.updateField(field);
    }
  }

  updateField(field){
    let data:any = {};
    data[field] = this.templateMission[field];
    console.log('Update mission with values:'+JSON.stringify(data));
    this.missionService.updateMission(this._mission, data);
  }

  resetFromTemplate(){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to reset mission texts from template in all languages?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        const skipFields = (this.templateMission.customRiddle || this._mission.customRiddle) ? Mission.customRiddleFields : [];
        let data:any = {};
        for(let field of Mission.translatedFields){
          if(skipFields.indexOf(field)<0){
            data[field] = this.templateMission[field];
          }
        }
        for(let field of Mission.translatedLists){
          if(skipFields.indexOf(field)<0){
            data[field] = this.templateMission[field];
          }
        }

        console.log('update from template:'+JSON.stringify(data));
        this.missionService.updateMission(this._mission, data);
      }
    });
  }

  async voiceGeneration(){
    const voiceFields = ['description', 'unlockedDescription', 'forkText', 'riddleText', 'successMessage', 'failMessage'];
    const lists = ['riddleAnswers', 'riddleClues', 'forkSelections', 'failMessageList'];
    for(let field of voiceFields){
      if(this._mission[field]){
        let model = this._mission[field];
        //basic/block
        if(model.blocks){
          for(let block of model.blocks){
            this.checkModelTTS(field, block);
          }
        }
        else{
          this.checkModelTTS(field, model);
        }
      }
    }
    
  }

  checkModelTTS(field, model){
    for(let lang of this.languages){
      /*
        do TTS if:
        - model has no id
        - model has no voice already linked
        - voice id mismatch
        - text hash mismatch
      */
      let doTTS = false;
      let refVoice;
      if(!model.id){
        doTTS = true;
      }
      else{
        let textData = this.getTextData(model, lang);
        if(this._mission.isEmpty(textData)){
          console.log('Empty text for '+field+' in '+lang);
          doTTS = false;
        }
        else{
          const modelVoices = this.voices.filter(voice => voice.elementId == model.id && voice.lang == lang);
          if(modelVoices.length == 0){
            console.log('No voice for '+field+' in '+lang);
            doTTS = true;
          }
          else{
            refVoice = modelVoices[0];
            if(refVoice.voiceId !== this.getTtsVoiceId(model, lang)){
              console.log('Voice id mismatch for '+field+' in '+lang);
              doTTS = true;
            }
            else{
              if(refVoice.textHash !== this.getTextHash(model, lang)){
                console.log('Text hash mismatch for '+field+' in '+lang);
                doTTS = true;
              }
            }
          }
        }
      }

      if(doTTS){
        console.log('TTS should be done for '+field+' in '+lang);
        //await this.doTTSAndSave(field, model, lang, refVoice)
      }
    }
  }

  needsTTsUpdate(model){
    if(model.type == 'dialog'){
      return true;
    }
  }

  getTtsVoiceId(model, lang){
    if(model.data?.characterId){
      for(let char of this.characters){
        if(char.id == model.data?.characterId){
          return char.getTtsVoiceId(model.data?.moodId, lang);
        }
      }
    }
    else if(this.game && this.game.getTtsVoiceId(lang)){
      return this.game.getTtsVoiceId(lang);
    }
    else if(this.template && this.template.getTtsVoiceId(lang)){
      return this.template.getTtsVoiceId(lang);
    }
    return null;
  }

  getTextData(model, lang){
    //model can be simple (lang map) or structured (object)
    if(model.data){
      if(model.type == 'dialog'){
        return model.data.text[lang];
      }
      else{
        return model.data[lang];
      }
    }
    return model[lang];
  }

  getTextHash(model, lang){
    return md5Hex(this.getTextData(model, lang));
  }

  async doTTSAndSave(attribute, model, lang, currentVoice){
    const audio = await this.voiceService.getAudio(this.getTextData(model, lang), this.getTtsVoiceId(model, lang));
    await this.saveVoice(attribute, model, lang, currentVoice, audio);
  }

  async saveVoice(attribute, model, lang, currentVoice, voiceBuffer){
    return new Promise((resolve, reject) => {
      const filePath = this.getStoragePath();
      if(!model.id){
        model.id = IdTools.makeIdAllChars(10);
        console.log('generate model id:'+model.id);
        let data = {};
        data[attribute] = model;
        this.save(data);
      }
      let voiceId;
      if(currentVoice){
        voiceId = currentVoice.id;
        console.log('existing voiceId:'+voiceId);
      }
      else{
        voiceId = this.voiceService.createVoiceRef(filePath).id;
        console.log('new voiceId:'+voiceId);
      }
      const txtHash = md5Hex(this.getTextData(model, lang));
      console.log('txt hash:'+txtHash);
      
      let fileName = `/${voiceId}.mp3`;

      console.log('check ref:'+filePath+fileName);

      let uploadRef = ref(this.storage, filePath+fileName);
      let task:any = uploadBytes(uploadRef, voiceBuffer);

      task.then(async () => {
        const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
        console.log('file uploaded to:'+url);
        let res = await this.createOrUpdateVoice(model, voiceId, this.getTtsVoiceId(model,lang), txtHash, lang, url, filePath+fileName, Math.round(voiceBuffer.byteLength));
        console.log('createMedia res:'+res);
        resolve(true);
      });
    });
  }

  async createOrUpdateVoice(model, voiceId, ttsVoiceId, textHash, lang, fileURL, filePath, fileSize){
    let voice = new Voice(this.getStoragePath());
    voice.id = voiceId;
    voice.elementId = model.id;
    voice.lang = lang;
    if(this.template){
      voice.templateId = this.template.id;
    }
    if(this.game){
      voice.gameId = this.game.id;
    }
    voice.textHash = textHash;
    voice.missionId = this._mission.id;
    voice.ttsVoiceId = ttsVoiceId;
    voice.fileURL = fileURL;
    voice.filePath = filePath;
    voice.fileSize = fileSize;
    voice.lastUpdate = new Date().getTime();
    console.log('media to add:'+JSON.stringify(voice));
    await this.voiceService.setVoice(voice);
    console.log('added media:'+voice.id);
  }

  getStoragePath(){
    let storagePath;
    if(this.game){
      storagePath = `games/${this.game.id}/voices`;
    }
    else{
      storagePath = `game_templates/${this.template.id}/voices`;
    }
    return storagePath;
  }

  async copySdr(){
    console.log('Copy mission to rGbMW1kyvEu32S8XoRuB');
    this._mission.id = 'rGbMW1kyvEu32S8XoRuB';
    await this.missionService.setMission(this._mission);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
